<template>
    <div id="app">
        <HeaderTop />
        <router-view></router-view>
    </div>
</template>

<script>
import HeaderTop from './components/HeaderTop.vue'

export default {
    name: 'App',
    components: { HeaderTop }
}
</script>

<style lang="less">
#app {
    width: 100%;
    height: 100vh;
}
</style>
